import React from 'react';
import TitleDetailDrawer from '../../../Title/TitleDetailDrawer';
import PropTypes from 'prop-types';
import { parseAndValidateTitleTag } from '../util/titleTag/regex';
import withIsMobile from 'treeline-react-core-components/WindowSizeProvider/withIsMobile';
import TitleMentionPopover from '../TitleMentionPopover/TitleMentionPopover';
import './titleMentionTag.less';

TitleMentionTag.propTypes = {
	titleTag: PropTypes.string,
	isMobile: PropTypes.func,
	popoverPlacement: PropTypes.string,
};

TitleMentionTag.defaultProps = {
	popoverPlacement: 'top',
};

function TitleMentionTag({ titleTag, isMobile, popoverPlacement }) {
	const { parsedTitle, parsedIsbn, isValidIsbn } = parseAndValidateTitleTag(
		titleTag,
	);
	const isMobileSize = isMobile();

	const titleTagAnchor = <span className="acc-font">{parsedTitle}</span>;

	const titleTagAnchorWithPopover = (
		<TitleMentionPopover
			parsedIsbn={parsedIsbn}
			placement={popoverPlacement}>
			{titleTagAnchor}
		</TitleMentionPopover>
	);

	return isValidIsbn ? (
		<div className="title-mention-tag-anchor">
			<TitleDetailDrawer
				sku={parsedIsbn}
				communityId={0}
				parentStyle="clickable drawer-anchor">
				{isMobileSize ? titleTagAnchor : titleTagAnchorWithPopover}
			</TitleDetailDrawer>
		</div>
	) : (
		<span>{parsedTitle}</span>
	);
}

export default withIsMobile(TitleMentionTag);
